import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  getChildrenGroups,
} from '@/api/groupserv'

export default {
  state: {
    state_Group_GetAllResult: null,
    state_Group_SearchByNameResult: null,
    state_Group_GetPageResult: null,
    state_Group_GetDetailResult: null,
    state_Group_DeleteObjResult: null,
    state_Group_GetChildrenGroupsResult: null,
  },
  mutations: {
    SET_GROUP_GETALL_RESULT: (state, rst) => {
      state.state_Group_GetAllResult = rst;
    },
    SET_GROUP_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_Group_SearchByNameResult = rst;
    },
    SET_GROUP_GETPAGE_RESULT: (state, rst) => {
      state.state_Group_GetPageResult = rst;
    },
    SET_GROUP_GETDETAIL_RESULT: (state, rst) => {
      state.state_Group_GetDetailResult = rst;
    },
    SET_GROUP_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Group_DeleteObjResult = rst;
    },
    SET_GROUP_GETCHILDRENGROUPS_RESULT: (state, rst) => {
      state.state_Group_GetChildrenGroupsResult = rst;
    },
  },
  actions: {
    GroupServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GROUP_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GROUP_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GroupServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GROUP_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GROUP_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GroupServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GROUP_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GROUP_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GroupServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GROUP_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GROUP_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GroupServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GROUP_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GROUP_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GroupServ_GetChildrenGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getChildrenGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GROUP_GETCHILDRENGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GROUP_GETCHILDRENGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Group_GetAllResult: state => {
      return state.state_Group_GetAllResult;
    },
    get_Group_SearchByNameResult: state => {
      return state.state_Group_SearchByNameResult;
    },
    get_Group_GetPageResult: state => {
      return state.state_Group_GetPageResult;
    },
    get_Group_GetDetailResult: state => {
      return state.state_Group_GetDetailResult;
    },
    get_Group_DeleteObjResult: state => {
      return state.state_Group_DeleteObjResult;
    },
    get_Group_GetChildrenGroupsResult: state => {
      return state.state_Group_GetChildrenGroupsResult;
    },
  }
}